<template>
    <div class="basic_wrap custom">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('Team Rewards')}}</div>
        </div>
        <div class="mt-20 content-wrap">
            <van-steps :active="activeStep" active-color="#07c160" direction="vertical">
                <van-step
                        v-for="(item, index) in rewardList"
                        :key="index"
                >
                    <div class="milestone">
                        <!-- 奖励展示 -->
                        <div class="reward">
                            🎁 {{$t('currency')}} {{ item.reward_amount }}
                        </div>

                        <!-- 充值金额 -->
                        <div class="amount">
                            {{$t('Team Recharge')}} {{$t('currency')}} {{ item.recharge_amount }}
                        </div>

                        <!-- 领取按钮 -->
                        <van-button
                                size="small"
                                :type="item.status === 2 ? 'warning' : 'primary'"
                                :disabled="item.status !== 1"
                                @click="claimReward(item, index)"
                        >
                            {{
                            item.status === 2
                            ? $t('Claimed')
                            : item.status === 1
                            ? $t('Claim')
                            : $t('Not achieved')
                            }}
                        </van-button>
                    </div>
                </van-step>
            </van-steps>
            <div class="rule-wrap">
                {{$t('Team Total Recharge Amount')}} : <span style="color:#76b900;font-size: 18px;font-weight: bold;">{{totalRecharge}}</span>
            </div>
            <div class="rule-wrap">
                <div class="font-14">{{rule.title}}</div>
                <div class="mt-20" v-html="rule.content"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import Fetch from "../../utils/fetch";

    export default {
        name: "teamAward",
        data() {
            return {
                rewardList: [],
                totalRecharge: 0,
                rule: {},
            };
        },
        computed: {
            // 当前进度对应的 step index
            activeStep() {
                let lastClaimedIndex = this.rewardList.map(r => r.status).lastIndexOf(2);
                return lastClaimedIndex;
            },
        },
        created() {
            this.$parent.footer('index', false);
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                Fetch('/index/teamReward', { }).then(res => {
                    this.rewardList = res.data.reward_list;
                    this.rule = res.data.rule;
                    this.totalRecharge = Number(res.data.total_recharge || 0).toFixed(2)
                })
            },
            claimReward(item, index) {
                if (item.status === 1) {
                    Fetch('/index/claimReward', { reward_id: item.id }).then(res => {
                        this.$toast('Successfully received');
                        this.rewardList[index].status = 2;

                        setTimeout(() => {
                            this.init();
                        }, 2000);
                    });
                }
            },
        },
    }
</script>

<style lang="less" scoped>
    .basic_wrap {
        background: #99c999;
        min-height: 100vh;
    }
    .back_left {
        background: url(../../views/images/item/back.png) no-repeat center center;
    }
    .big_tit{
        color: #fff;
    }
    .red_top_bg {
        background: unset;
    }
    .milestone {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 8px;
    }
    .reward {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 4px;
    }
    .amount {
        font-size: 12px;
        color: #666;
        margin-bottom: 6px;
    }
    .rule-wrap {
        margin-top: 20px;
        background: #fff;
        border-radius: 8px;
        padding: 20px;
    }
</style>